import React, { Fragment } from "react";
import { Container } from "reactstrap";
import MdeExampleOne from "./MdeExampleOne";
import MdeExampleTwo from "./MdeExampleTwo";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Editors, MDEEditor } from "../../../../Constants/Constants";

const MdeEditorContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={MDEEditor} parent={Editors} />
      <Container fluid>
        <MdeExampleOne />
        <MdeExampleTwo />
      </Container>
    </Fragment>
  );
};

export default MdeEditorContainer;
